// Put your applicaiton javascript here
window.flashyNextArrow = `
    <button class="slick-next slick-arrow" aria-label="Next" type="button" style="">
    <svg enable-background="new 0 0 129 129" version="1.1" viewBox="0 0 129 129" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg">
        <g>
            <path d="m40.4,121.3c-0.8,0.8-1.8,1.2-2.9,1.2s-2.1-0.4-2.9-1.2c-1.6-1.6-1.6-4.2 0-5.8l51-51-51-51c-1.6-1.6-1.6-4.2 0-5.8 1.6-1.6 4.2-1.6 5.8,0l53.9,53.9c1.6,1.6 1.6,4.2 0,5.8l-53.9,53.9z"/>
        </g>
    </svg>
    </button>
    `;

window.flashyPrevArrow = `
    <button class="slick-prev slick-arrow" aria-label="Previous" type="button" style="">
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 129 129">
        <g>
        <path d="m88.6,121.3c0.8,0.8 1.8,1.2 2.9,1.2s2.1-0.4 2.9-1.2c1.6-1.6 1.6-4.2 0-5.8l-51-51 51-51c1.6-1.6 1.6-4.2 0-5.8s-4.2-1.6-5.8,0l-54,53.9c-1.6,1.6-1.6,4.2 0,5.8l54,53.9z"/>
        </g>
    </svg>
    </button>
    `;

// Mega menú: posicionar dropper debajo del ítem activo
$(document).ready(function () {
  setTimeout(function () {
    $('.megamenu-item .primary-link').off('mouseenter mouseleave');
    $('.megamenu-item').off('mouseenter mouseleave');

    $('.megamenu-item .primary-link').hover(function (e) {
      var $item = $(this).parent('.megamenu-item');
      var $dropper = $item.children('.dropper');
      if (!$dropper.length) return;

      if (e.type === 'mouseenter') {
        $('.megamenu-item .dropper').hide();
        $dropper.css('top', $('.main-header').height() - 15);
        $dropper.show();

        var itemRect = $item[0].getBoundingClientRect();
        var dropperWidth = $dropper.outerWidth();
        var viewportWidth = $(document).width();

        // Centrar el dropper bajo el ítem activo
        var left = itemRect.left + itemRect.width / 2 - dropperWidth / 2;
        // Evitar que se salga del viewport
        left = Math.max(10, Math.min(left, viewportWidth - dropperWidth - 10));
        $dropper.css('left', left);
      }
    });

    $('.megamenu-item').hover(function (e) {
      if (e.type === 'mouseleave') {
        $(this).children('.dropper').hide();
      }
    });
  }, 300);
});
